/**
 * CSRF token helper for write requests. The server sets a `csrf_token`
 * cookie on session creation; we echo it back via the `x-csrf-token`
 * header on POST/PUT/DELETE.
 */
export function getCsrfHeader(): Record<string, string> {
  const m = document.cookie.match(/(?:^|;\s*)csrf_token=([^;]+)/);
  return m ? { "x-csrf-token": m[1] } : {};
}
